export default __webpack_public_path__ + "static/media/delete-icon.9ab191db.svg";